import React, { useState, useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import BlogIcon01 from '../assets/blog-icon-01.png';
import BlogIcon02 from '../assets/blog-icon-02.png';
import BlogIcon03 from '../assets/blog-icon-03.png';
import BlogIcon04 from '../assets/blog-icon-04.png';
import BlogIcon05 from '../assets/blog-icon-05.png';
import BlogImg01 from '../assets/blog/choose-best-camera.png';
import BlogImg02 from '../assets/blog/future-of-smart-home.png';
import BlogImg03 from '../assets/blog/battery.png';
import BlogImg04 from '../assets/blog/wireless-security.png';
import BlogImg05 from '../assets/blog/fix-wifi.png';
import SearchIcon from '../assets/search-icon.png';
import { Layout } from '../components/page-layout';

const GlobalStyle = createGlobalStyle`
  body {
    background: #fff;
    color: #222;
    font-size: 18px;
    letter-spacing: 0;
  }
`;

const Main = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 1.5rem;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: #F87B15;
  text-align: center;
  margin-bottom: 0.7rem;
  line-height: 1.2;
`;

const Description = styled.p`
  text-align: center;
  color: #666;
  margin-bottom: 2rem;
  line-height: 1.7;
`;

const SearchBarWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
`;

const SearchBarInner = styled.div`
  position: relative;
  width: 100%;
  max-width: 590px;
`;

const SearchInput = styled.input`
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 0.75rem 1rem 0.75rem 3rem;
  width: 100%;
  font-size: 1rem;
  background: #fff;
  outline: none;
`;

const SearchIconImg = styled.img`
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
`;

const Categories = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
  @media (min-width: 900px) {
    flex-direction: row;
    justify-content: center;
    gap: 1.5rem;
  }
`;

const CategoryCard = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 1.5rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 140px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
`;

const CategoryIconWrapper = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 50%;
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
`;

const CategoryIcon = styled.img`
  width: 48px;
  height: 48px;
`;

const CategoryLabel = styled.span`
  font-size: 1.1rem;
  text-align: center;
`;

const SectionTitle = styled.h2`
  font-size: 2rem;
  text-align: center;
  margin-bottom: 1.5rem;
  line-height: 1.2;
`;

const BlogCardsRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
  @media (min-width: 900px) {
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    gap: 2rem;
  }
`;

const BlogCard = styled.a`
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
  text-decoration: none;
  color: inherit;
  transition: box-shadow 0.2s, border 0.2s;
  cursor: pointer;
  &:hover {
    box-shadow: 0 4px 24px rgba(248,123,21,0.10);
    border: 1.5px solid #F87B15;
  }
`;

const BlogImg = styled.img`
  width: 100%;
  height: 192px;
  object-fit: cover;
  border-radius: 16px 16px 0 0;
`;

const BlogContent = styled.div`
  padding: 1.25rem;
`;

const BlogHeading = styled.h3`
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 0.3rem;
  line-height: 1.35;
`;

const BlogMeta = styled.p`
  font-size: 0.95rem;
  color: #888;
  display: flex;
  justify-content: space-between;
`;

const OtherBlogsSection = styled.div`
  margin-top: 2.5rem;
`;

const FeaturedCardsRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
  @media (min-width: 900px) {
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    gap: 2rem;
  }
`;

const FeaturedCard = styled.a`
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
  text-decoration: none;
  color: inherit;
  transition: box-shadow 0.2s, border 0.2s;
  cursor: pointer;
  &:hover {
    box-shadow: 0 4px 24px rgba(248,123,21,0.10);
    border: 1.5px solid #F87B15;
  }
`;

const FeaturedImg = styled.img`
  width: 100%;
  height: 192px;
  object-fit: cover;
  border-radius: 16px 16px 0 0;
`;

const FeaturedContent = styled.div`
  padding-left: 1rem;
`;

const FeaturedHeading = styled.h3`
  font-size: 1.1rem;
  word-spacing: 0rem;
  letter-spacing: 0rem;
  font-weight: 700;
  line-height: 1.5;
`;

const FeaturedMeta = styled.p`
  font-size: 0.95rem;
  color: #888;
  display: flex;
  justify-content: space-between;
`;

// Blog data for filtering (with content)
const blogPosts = [
  {
    title: 'How to Choose the Best Home Camera for Your Needs',
    slug: 'how-to-choose-the-best-home-cameras-for-your-needs',
    img: BlogImg01,
    content: `Wired Cameras are great if you have a convenient power source nearby. They're typically more reliable over time, with no worries about recharging batteries. Plus, they often support higher video quality. Wireless cameras, on the other hand, give you flexibility. No drilling or complex installation—just place it where you need and connect to Wi-Fi. Perfect for renters or areas where outlets are limited. Just keep in mind: you'll need to stay on top of battery life. Pro tip: If you're not sure, start with a wireless model. It's easier to experiment with placement before committing. Every space has its own needs. For small rooms, entryways, or narrow hallways, a fixed-angle camera might be more than enough. But if you're looking to cover a large space—like a living room, garage, or backyard—consider a Pan-tilt Camera. These can swivel horizontally and tilt vertically, to give you more complete coverage with just one device. Indoor Cameras are usually designed with aesthetics and discretion in mind. They're smaller, quieter, and fit nicely into home decor. Outdoor cameras are built tougher—with weatherproofing, better night vision, and wider detection ranges to handle the elements and longer distances. The best cameras do more than just record. Look for features like: Motion detection with alerts, Two-way audio (so you can speak through the camera), Night vision, AI-powered detection (categorize clips by people, pets, vehicles, etc.), App support with livestream, playback, and customization options. Home cameras give you peace of mind—but they also raise privacy questions. Choose a brand that lets you: Turn cameras on/off remotely, Include a privacy shutter, Mask certain areas from detection, Use encrypted storage and secure cloud accounts. Your home should feel safer—not more exposed. There's no one-size-fits-all home camera. The best choice depends on your space, lifestyle, and what gives you peace of mind. Many users love to pair cameras together to enjoy indoor, outdoor, and on-the-go video! Start with your needs, and you'll find a camera that truly works for you.`
  },
  {
    title: 'The Future of Smart Homes: What You Need to Know',
    slug: 'the-future-of-smart-homes',
    img: BlogImg02,
    content: `Smart homes are getting smarter—fast. What started with voice-activated lights and motion alerts is now evolving into deeply connected, adaptive ecosystems that enhance safety, comfort, and convenience. As we step into the next chapter of smart living, here are the biggest trends to watch—and how to choose the right tools to stay ahead. Seamless Integration Is the New Standard: In the future, smart homes won't be a patchwork of disconnected gadgets. Instead, devices will work in harmony—coordinating commands across cameras, lights, sensors, and assistants. Example: Your Sensforge Indoor Pan-Tilt Camera detects motion — your hallway lights turn on — you get a real-time alert on your phone. All automated, no extra input needed. Smart Homes Will Support the Whole Family: Today's smart systems often cater to the main user. But the future? It's multi-user, multi-generational, and shared. Tiered access levels: Let roommates, kids, or caregivers interact with smart devices with limited permissions. User-specific profiles: Devices learn individual preferences—like lighting or temperature—and adapt automatically. SensRing (coming soon): A sleek, elder-friendly smart ring that pairs with home cameras for motion detection, wellness monitoring, and quick emergency notifications. Privacy Will Be Built In—Not Added On: With more devices comes more responsibility. The best smart homes of tomorrow will prioritize: Encrypted video files, Custom privacy zones (mask off areas like the bedroom), Scheduled privacy times for when you're home and don't want to be recorded. The Sensforge Indoor Pan-Tilt Camera offers customizable privacy masks and encrypted local storage options, giving you full control over what gets recorded and when. Control Will Be More Natural—Less Manual: Forget digging through apps. Smart homes will increasingly rely on AI and intuitive interfaces, like: Voice + gesture commands, Proactive automation (e.g., lights dim when you start a movie), Presence detection that adjusts settings based on who's home. Sensforge devices are built with AI-powered motion tracking and event recognition, making daily automation smoother and smarter. Smarter Security & Wellness Monitoring: Security is no longer just about recording footage—it's about being proactive, especially for families caring for elders or young children. AI alerts for falls, abnormal movement, or inactivity. Integration between wearables + cameras for contextual awareness. Emergency assistance with one-tap or auto-triggered alerts. The SensRing + Camera Care Set (coming soon!): Designed to keep aging family members safe by reporting abnormal biometrics and video context to loved ones—all with dignity and discretion in mind. Final Takeaway: Smarter, Safer, Simpler. The smart home of the future isn't just about more gadgets. It's about a thoughtful system that adapts to your life—while capturing everyday memories and keeping your data private. As you explore your own smart home journey, look for: Devices that integrate easily, Features that benefit everyone in your household, Clear, built-in privacy controls, Practical innovations—not just flashy ones. Looking to turn your home into a smart home? Check out Sensforge's Indoor Pan-Tilt Camera for a 360-degree view and AI-powered detection, or sign up to be the first to know about our SensRing + Elder Care Set here.`
  },
  {
    title: 'Why Battery Life is a Challenge for Wireless Security Cameras',
    slug: 'why-battery-life-is-a-challenge-for-wireless-security-cameras',
    img: BlogImg03,
    content: `Wireless cameras are a hit with homeowners—they're easy to install, flexible, and don't require drilling holes or wiring. But there's one recurring frustration: battery life. Let's break down how to get the most out of your wireless camera. The Power Trade-Off: Battery cameras are designed for convenience, but that comes at a cost. Since they rely entirely on battery power, they need to strike a balance between performance and efficiency. Every camera feature—motion detection, night vision, recording, notifications—consumes power. Manufacturers have to decide how much performance they can deliver without draining the battery too fast. In short: More features = higher power draw. Better battery life = fewer features or reduced performance. Efficiency Makes a Big Difference: At the core of every camera is a chipset that manages video processing, Wi-Fi communication, and smart features like AI alerts. Some chips are optimized for performance but use more power, while others are designed to conserve energy. A camera's battery life often comes down to how efficient its internal components are. AI motion filtering (to reduce false alerts), Power-conscious chipsets, Privacy-first storage choices (local and cloud), Solar panels for outdoor cameras. Final Thoughts: Battery life is one of the biggest challenges in wireless camera design—and it's influenced by much more than just the battery itself. Understanding how hardware, weather, settings, and storage all play a role can help you choose the right camera for your space—and make each charge go further. Looking for a battery-free indoor option? Check out Sensforge Indoor Pan-Tilt Camera for 24/7 protection without ever needing a recharge.`
  },
  {
    title: 'Wireless Security Systems: Are They Safe Enough?',
    slug: 'wireless-security-systems-are-they-safe-enough',
    img: BlogImg04,
    content: `Wireless security cameras and systems are booming in popularity—and for good reason. They're easy to install, flexible, and often come packed with smart features. But there's a big question that comes up often: "Are wireless security systems actually safe?" Let's break it down: what the real risks are, what security features to look for, and how you can protect your home without sacrificing convenience. Understanding the Concern: Unlike traditional wired systems that are physically connected, wireless systems rely on your home Wi-Fi network to transmit footage and alerts. That means: Footage is often stored in the cloud or transmitted wirelessly. Data is vulnerable to interception if not protected. Devices are only as secure as your home network. So yes—wireless systems come with some security considerations. But that doesn't mean they're inherently unsafe. The key is understanding the risks and choosing the right brand. Common Wireless Security Risks: Here are a few of the most talked-about concerns: Footage is often stored in the cloud or transmitted wirelessly. Data is vulnerable to interception if not protected. Devices are only as secure as your home network. At Sensforge, we believe security shouldn't come at the cost of convenience. That's why our upcoming smart home products prioritize user privacy: AES-encrypted SD card storage to protect footage. Physical privacy shutters for instant control. Two-factor authentication for account security. On-device AI motion detection to reduce unnecessary uploads. ( Our indoor pan-tilt cameras and upcoming smart ring system are designed with a "privacy-first" mindset—because peace of mind should feel secure and personal. ) Final Takeaway: Yes—wireless security systems can be safe. But only when paired with the right features, strong passwords, and smart practices. By choosing devices with encryption, local storage, and privacy controls—and by securing your home network—you can enjoy the flexibility of wireless without compromising on safety.`
  },
  {
    title: "Why Your Security Camera Won't Connect to Wi-Fi—And How to Fix It",
    slug: 'why-your-security-camera-wont-connect-to-wifi',
    img: BlogImg05,
    content: `Connecting a security camera to Wi-Fi doesn't have to be frustrating. Most issues come down to Wi-Fi band compatibility, signal strength, or a few simple setup missteps. At Sensforge, we know setup is the first impression—so we're making it as smooth as possible. Guided in-app setup with smart error detection. 2.4GHz-only pairing with clear prompts. WiFi signal check tools to help you find optimal camera placement. Easy reset button for quick retries if something goes wrong. YouTube tutorial videos – click here! Blog posts like these! Looking for an indoor security camera that just works? Explore the Sensforge Indoor Pan-Tilt Camera — designed with intuitive setup and rock-solid connectivity. Final Thoughts: Connecting a security camera to Wi-Fi doesn't have to be frustrating. Most issues come down to Wi-Fi band compatibility, signal strength, or a few simple setup missteps. By understanding these common pain points, you'll be better equipped to troubleshoot quickly and get your camera online — capturing what matters most.`
  },
];

const BlogsPage = () => {
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
    }, 200);
    return () => clearTimeout(handler);
  }, [search]);

  // Filter posts by debounced search (case-insensitive, by title or content)
  const filteredPosts = blogPosts.filter(post =>
    post.title.toLowerCase().includes(debouncedSearch.toLowerCase()) ||
    post.content.toLowerCase().includes(debouncedSearch.toLowerCase())
  );

  return (
    <Layout showCommonFooter>
      <GlobalStyle />
      <Main>
        <Title>Blogs</Title>
        <Description>
          Welcome to the Sensforge Blog—your destination for insights, inspiration, and tips on capturing life&apos;s most spontaneous moments. Here, we share our journey in smart home technology, offer practical advice on preserving everyday memories, and dive into heartwarming customer stories. Enjoy reading and feel free to share your own experiences with us!
        </Description>
        <SearchBarWrapper>
          <SearchBarInner>
            <SearchIconImg src={SearchIcon} alt="Search Icon" />
            <SearchInput
              type="text"
              placeholder="What are you looking for?"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </SearchBarInner>
        </SearchBarWrapper>
        <Categories>
          <CategoryCard>
            <CategoryIconWrapper>
              <CategoryIcon src={BlogIcon01} alt="Tech Innovations" />
            </CategoryIconWrapper>
            <CategoryLabel>Tech Innovations</CategoryLabel>
          </CategoryCard>
          <CategoryCard>
            <CategoryIconWrapper>
              <CategoryIcon src={BlogIcon02} alt="Smart Home Solutions" />
            </CategoryIconWrapper>
            <CategoryLabel>Smart Home Solutions</CategoryLabel>
          </CategoryCard>
          <CategoryCard>
            <CategoryIconWrapper>
              <CategoryIcon src={BlogIcon03} alt="Surveillance" />
            </CategoryIconWrapper>
            <CategoryLabel>Surveillance</CategoryLabel>
          </CategoryCard>
          <CategoryCard>
            <CategoryIconWrapper>
              <CategoryIcon src={BlogIcon04} alt="Battery-Powered Devices" />
            </CategoryIconWrapper>
            <CategoryLabel>Battery-Powered Devices</CategoryLabel>
          </CategoryCard>
          <CategoryCard>
            <CategoryIconWrapper>
              <CategoryIcon src={BlogIcon05} alt="Tech DIY" />
            </CategoryIconWrapper>
            <CategoryLabel>Tech DIY</CategoryLabel>
          </CategoryCard>
        </Categories>
        <SectionTitle>Featured Blogs</SectionTitle>
        <BlogCardsRow>
          {filteredPosts.slice(0, 3).map(post => (
            <FeaturedCard href={`/${post.slug}`} key={post.slug}>
              <FeaturedImg src={post.img} alt={post.title} />
              <FeaturedContent>
                <FeaturedHeading>{post.title}</FeaturedHeading>
                <FeaturedMeta>
                  <span>By Sensforge Team</span>
                </FeaturedMeta>
              </FeaturedContent>
            </FeaturedCard>
          ))}
        </BlogCardsRow>
        <OtherBlogsSection>
          <SectionTitle>Other Blogs</SectionTitle>
          <BlogCardsRow>
            {filteredPosts.slice(3).map(post => (
              <FeaturedCard href={`/${post.slug}`} key={post.slug}>
                <FeaturedImg src={post.img} alt={post.title} />
                <FeaturedContent>
                  <FeaturedHeading>{post.title}</FeaturedHeading>
                  <FeaturedMeta>
                    <span>By Sensforge Team</span>
                  </FeaturedMeta>
                </FeaturedContent>
              </FeaturedCard>
            ))}
          </BlogCardsRow>
        </OtherBlogsSection>
      </Main>
    </Layout>
  );
};

export default BlogsPage;
